import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Alert, AlertProps, Box, SxProps, Theme, Typography, useTheme } from "@mui/material";
import React from "react";

export type MessageAlertProps = {
    severity: AlertProps["severity"];
    text: string | React.ReactNode;
    sx?: SxProps<Theme>;
};

export const MessageAlert = ({ severity = "info", text, sx }: MessageAlertProps) => {
    const theme = useTheme();

    const iconColor =
        severity === "error"
            ? theme.palette.error.dark
            : severity === "warning"
              ? theme.palette.warning.dark
              : severity === "success"
                ? theme.palette.success.dark
                : theme.palette.info.dark;

    const alertIcon =
        severity === "error" ? (
            <WarningAmberOutlinedIcon sx={{ width: 16, height: 16, color: iconColor }} />
        ) : (
            <InfoOutlinedIcon sx={{ width: 16, height: 16, color: iconColor }} />
        );

    return (
        <Alert
            severity={severity}
            icon={false}
            sx={[
                {
                    padding: "16px",
                    ".MuiAlert-message": { padding: 0 },
                    marginTop: "12px",
                },
                severity === "warning" && {
                    border: `1px solid ${theme.palette.warning.main}`,
                },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
        >
            <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ marginTop: "6px" }}>{alertIcon}</Box>
                <Typography variant="subtitle1" color="text.primary" component="div" sx={{ flex: 1, width: "100%" }}>
                    {typeof text === "string" ? (
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: text,
                            }}
                            sx={{ width: "100%" }}
                        />
                    ) : (
                        text
                    )}
                </Typography>
            </Box>
        </Alert>
    );
};
